<template>
  <el-container class="CustomerBulkChange">
    <el-main class="p-0">
      <el-form
        ref="form"
        class="form-label-90"
        label-width="90px"
        :model="data"
        :rules="rules"
      >
        <el-form-item prop="customer_level_id" label="기계등급">
          <el-checkbox v-model="selection.customer_level_id" />
          <el-select
            v-model="data.customer_level_id"
            class="ml-default"
            placeholder="기계등급"
            @change="handleChangeCustomerLevelId"
          >
            <el-option
              v-for="item in customer_level_options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item prop="customer_glass_level_id" label="유리등급">
          <el-checkbox v-model="selection.customer_glass_level_id" />
          <el-select
            v-model="data.customer_glass_level_id"
            class="ml-default"
            placeholder="유리등급"
            @change="handleChangeGlassCustomerLevelId"
          >
            <el-option
              v-for="item in customer_glass_level_options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item prop="customer_foreign_flag" label="해외 거래처">
          <el-checkbox v-model="selection.customer_foreign_flag" />
          <el-radio-group
            v-model="data.customer_foreign_flag"
            class="pl-default"
          >
            <el-radio-button label="N">국내</el-radio-button>
            <el-radio-button label="Y">해외</el-radio-button>
          </el-radio-group>
        </el-form-item>
      </el-form>
    </el-main>
    <el-footer>
      <el-button
        type="primary"
        v-shortkey="['F4']"
        :disabled="disableRegister && has_grant_write"
        @shortkey.native="handleClickRegister"
        @click="handleClickRegister"
        >{{ $t("button.register") }}(F4)</el-button
      >
      <el-button class="close-button" @click="handleCloseDialog"
        >{{ $t("button.close") }}(Esc)</el-button
      >
    </el-footer>
  </el-container>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "CustomerBulkChange",
  data() {
    let validateCustomerLevelId = (rule, value, callback) => {
      if (!this.selection.customer_level_id || this.data.customer_level_id) {
        callback();
      } else {
        callback(new Error("기계등급을 선택해 주세요."));
      }
    };
    let validateGlassCustomerLevelId = (rule, value, callback) => {
      if (
        !this.selection.customer_glass_level_id ||
        this.data.customer_glass_level_id
      ) {
        callback();
      } else {
        callback(new Error("유리등급을 선택해 주세요."));
      }
    };
    let validateCustomerForeignFlag = (rule, value, callback) => {
      if (
        !this.selection.customer_foreign_flag ||
        this.data.customer_foreign_flag
      ) {
        callback();
      } else {
        callback(new Error("재고관리 옵션을 선택해 주세요."));
      }
    };
    return {
      title: this.$t("title.customer"),
      selection: {
        customer_level_id: false,
        customer_glass_level_id: false,
        customer_foreign_flag: false,
      },
      data: {
        customer_level_id: null,
        customer_glass_level_id: null,
        customer_foreign_flag: null,
      },
      rules: {
        customer_level_id: [
          { validator: validateCustomerLevelId, trigger: "blur" },
        ],
        customer_glass_level_id: [
          { validator: validateGlassCustomerLevelId, trigger: "blur" },
        ],
        customer_foreign_flag: [
          { validator: validateCustomerForeignFlag, trigger: "blur" },
        ],
      },
    };
  },
  props: {
    ids: {
      type: Array,
      required: true,
    },
    has_grant_write: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(["table_customer_level", "table_customer_glass_level"]),
    customer_level_options: function() {
      let options = [{ value: null, label: "" }];
      this.table_customer_level.forEach((l) => {
        options.push({ value: l.id, label: l.code });
      });
      return options;
    },
    customer_glass_level_options: function() {
      let options = [{ value: null, label: "" }];
      this.table_customer_glass_level.forEach((l) => {
        options.push({ value: l.id, label: l.code });
      });
      return options;
    },
    disableRegister() {
      return (
        !this.selection.customer_level_id &&
        !this.selection.customer_glass_level_id &&
        !this.selection.customer_foreign_flag
      );
    },
  },
  methods: {
    doRegister() {
      let data = {};
      if (this.selection.customer_level_id) {
        data.customer_level_id = this.data.customer_level_id;
      }
      if (this.selection.customer_glass_level_id) {
        data.customer_glass_level_id = this.data.customer_glass_level_id;
      }
      if (this.selection.customer_foreign_flag) {
        data.customer_foreign_flag = this.data.customer_foreign_flag;
      }
      let param = {
        ids: this.ids,
        data: data,
      };
      this.api.updateCustomerBulk(param).then((res) => {
        if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, this.title, res);
          return;
        }
        this.util.notify_success(this, this.title, "등록되었습니다.");
        this.$emit("completed");
      });
    },
    handleChangeCustomerLevelId() {
      this.selection.customer_level_id = !!this.data.customer_level_id;
    },
    handleChangeGlassCustomerLevelId() {
      this.selection.customer_glass_level_id = !!this.data
        .customer_glass_level_id;
    },
    handleClickRegister() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        this.doRegister();
      });
    },
    handleCloseDialog() {
      this.$emit("completed");
    },
  },
};
</script>
